import React from 'react';
import { Link } from 'react-router-dom';

const LinkIcon = ({ route, icon, classes }) => {
	return (
		<Link to={route}>
			<i className={`${icon} ${classes} p-2 rounded-2 fs-4`}></i>
		</Link>
	);
};

export default LinkIcon;
